module.exports = __webpack_public_path__ + "img/no-permission-min.0e5b783d.svg";